"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopProduct = void 0;
var shop_product_1 = require("../enums/shop-product");
var upsell_modal_1 = require("../constants/data/upsell-modal");
var Afterpay = require("../constants/afterpay");
var ShopProduct = exports.ShopProduct = /** @class */ (function () {
    function ShopProduct(products, product) {
        var _this = this;
        this.products = products;
        this.highestPrice = 0;
        // Create product Map from products array
        this.shopProductMap = this.products.reduce(function (acc, curr) {
            var _b, _c;
            var _d;
            var newAcc = __assign({}, acc);
            var metaData = ShopProduct.getMetaData(curr);
            if (metaData) {
                // Copy the existing productMap values and add a new product to the appropriate location
                newAcc[metaData.option] = __assign(__assign({}, newAcc[metaData.option]), (_b = {}, _b[metaData.type] = __assign(__assign({}, (_d = newAcc[metaData.option]) === null || _d === void 0 ? void 0 : _d[metaData.type]), (_c = {}, _c[metaData.quantity] = curr, _c)), _b));
                // Calculate the highestPrice
                _this.highestPrice = Math.max(_this.highestPrice, +curr.priceRange.minVariantPrice.amount);
            }
            else {
                // Generic error message about missing / irregular meta fields
                console.error("Metafields for product \"".concat(curr.title, "\" had following error(s).\n            This product is not added to productMap, thus shop section may not function as expected."));
                // More detailed error message for dev
                // TODO
            }
            return newAcc;
        }, {});
        this.brand = shop_product_1.ShopBrand.default;
        this.defaultSelection = this.createDefaultSelection(product || products[0]);
    }
    ShopProduct.isEnum = function (value, checkedEnum) {
        return Object.values(checkedEnum).includes(value);
    };
    ShopProduct.prototype.getProductBySelection = function (option, type, quantity) {
        var _b, _c;
        return (_c = (_b = this.shopProductMap[option]) === null || _b === void 0 ? void 0 : _b[type]) === null || _c === void 0 ? void 0 : _c[quantity];
    };
    ShopProduct.prototype.getPricesByVariant = function (variant) {
        return {
            price: variant === null || variant === void 0 ? void 0 : variant.price,
            compareAtPrice: variant === null || variant === void 0 ? void 0 : variant.compareAtPrice,
        };
    };
    ShopProduct.prototype.getCurrentProduct = function (selection) {
        return this.getProductBySelection(selection.option, selection.type, selection.quantity);
    };
    ShopProduct.prototype.getCurrentVariant = function (selection) {
        var product = this.getCurrentProduct(selection);
        return product && ShopProduct.getVariantByProduct(product);
    };
    ShopProduct.prototype.getPricesByType = function (selection, type) {
        var product = this.getProductBySelection(selection.option, type, selection.quantity);
        var variant = product && ShopProduct.getVariantByProduct(product);
        return this.getPricesByVariant(variant);
    };
    ShopProduct.prototype.createDefaultSelection = function (product) {
        // If product is provided, try to use it for default product for PDP
        if (product) {
            var metaData = ShopProduct.getMetaData(product);
            if (metaData) {
                return metaData;
            }
        }
        for (var _i = 0, _b = this.products; _i < _b.length; _i++) {
            var prod = _b[_i];
            var metaData = ShopProduct.getMetaData(prod);
            if (metaData) {
                return metaData;
            }
        }
        throw new Error('');
    };
    ShopProduct.prototype.getDefaultSelection = function () {
        return this.defaultSelection;
    };
    ShopProduct.prototype.getBrand = function () {
        return this.brand;
    };
    ShopProduct.prototype.shouldShowAfterpay = function (selection) {
        return (this.highestPrice >= Afterpay.MINIMUM_PRICE &&
            selection.type === shop_product_1.TypeKey.oneTime);
    };
    ShopProduct.getVariantByProduct = function (product) {
        return product.variants.nodes[product.variants.nodes.length - 1];
    };
    ShopProduct.getUpsellModal = function (product) {
        var _b;
        var upsellModalName = (_b = product.metafields.find(function (val) { return (val === null || val === void 0 ? void 0 : val.key) === 'upsell_modal_name'; })) === null || _b === void 0 ? void 0 : _b.value;
        if (!upsellModalName || !(upsellModalName in upsell_modal_1.upsellModalMap)) {
            console.error("Upsell Modal is not rendered due to the following error:");
            if (!upsellModalName) {
                console.error("upsellModalName is undefined or null. Check the product's meta field \"upsell_modal_name\" and make sure an appropriate value is set on Shopify admin", "product:", product);
            }
            else if (!(upsellModalName in upsell_modal_1.upsellModalMap)) {
                console.error("upsellModalName \"".concat(upsellModalName, "\" does not exist in \"upsellModalMap\" object. Check the upsellModalMap in /consts/data/upsell-modal.ts"), "upsellModalName: ".concat(upsellModalName), "upsellModalMap:", upsell_modal_1.upsellModalMap);
            }
            else {
                console.error('error reason unknown.');
            }
            return null;
        }
        return upsell_modal_1.upsellModalMap[upsellModalName];
    };
    var _a;
    _a = ShopProduct;
    ShopProduct.getMetaData = function (prod) {
        var _b, _c, _d, _e, _f;
        // Find meta field values (type & includes)
        var metaType = (_b = prod.metafields.find(function (val) { return (val === null || val === void 0 ? void 0 : val.key) === 'type'; })) === null || _b === void 0 ? void 0 : _b.value;
        var metaIncludes = (_c = prod.metafields.find(function (val) { return (val === null || val === void 0 ? void 0 : val.key) === 'includes'; })) === null || _c === void 0 ? void 0 : _c.value;
        var option = null;
        var quantity = 0;
        // If there is ',' in the include field, assign bundle to option
        if (metaIncludes === null || metaIncludes === void 0 ? void 0 : metaIncludes.includes(',')) {
            option = shop_product_1.OptionKey.bundle;
            // Sum up the number present in includes field
            quantity =
                ((_d = metaIncludes === null || metaIncludes === void 0 ? void 0 : metaIncludes.match(/(\d+)/g)) === null || _d === void 0 ? void 0 : _d.reduce(function (acc, curr) {
                    if (Number.isInteger(+curr)) {
                        return acc + +curr;
                    }
                    return acc;
                }, 0)) || 0;
            // to accomodate multi product bundel that can have quantity larger than 3
            if (quantity > 3) {
                quantity = 3;
            }
        }
        else {
            // Get product option from includes meta field (gummy | capsule | otc)
            var optionVal = metaIncludes === null || metaIncludes === void 0 ? void 0 : metaIncludes.split('=')[0].split('-').pop();
            if (optionVal && _a.isEnum(optionVal, shop_product_1.OptionKey)) {
                option = optionVal;
                // Get the first number in includes as the number of bottle (default: 0)
                quantity = +((_f = (_e = metaIncludes === null || metaIncludes === void 0 ? void 0 : metaIncludes.match(/(\d+)/g)) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : '0');
            }
            else {
                option = shop_product_1.OptionKey.other;
                quantity = 1;
            }
        }
        if (metaType &&
            _a.isEnum(metaType, shop_product_1.TypeKey) &&
            option &&
            _a.isEnum(option, shop_product_1.OptionKey) &&
            quantity > 0 &&
            quantity < 4) {
            return {
                option: option,
                type: metaType,
                quantity: quantity,
            };
        }
        else {
            // Generic error message about missing / irregular meta fields
            console.error("Metafields for product \"".concat(prod.title, "\" had following error(s).\n          This product is not added to productMap, thus shop section may not function as expected."), 'metaType: ', metaType, 'metaIncludes: ', metaIncludes);
            // More detailed error message for dev
            // TODO
            return null;
        }
    };
    return ShopProduct;
}());
